import { DateTime } from 'luxon'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPencilAlt } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Button, ListItem, Text,
} from '@domain-group/suit-theme'

import type { OrderItemModel } from '@models/types'

import { buildItemTitle, getPublicationItemStatusString } from '@functions/orderItem'

import useOrderItem from '@hooks/useOrderItem'
import useRedirectUrlWithCacheKey from '@hooks/useRedirectUrlWithCacheKey'

import OrderItemOrQuoteItemManagement from '@components/OrderItemOrQuoteItemManagement'

interface OrderItemProps {
  orderItem: OrderItemModel,
}

const OrderItem = (props: OrderItemProps) => {
  const { orderItem } = props

  const orderItemPayload = useOrderItem(orderItem)
  const {
    artworkApproved,
    callbacks: {
      manageOrderItem,
    },
    isBeforeBookingDeadline,
    isPaginated,
    orderBundle = {},
    orderStatus,
    publication,
    publicationEdition: {
      publication_date,
    },
    publicationPackage = {},
  } = orderItemPayload

  const publicationDateObj = publication_date ? DateTime.fromFormat(publication_date, 'dd/MM/yyyy') : null

  const bookingStatusString = getPublicationItemStatusString({
    artworkApproved,
    isBeforeBookingDeadline,
    // @ts-expect-error TS2339
    orderStatusKey: orderStatus.key,
  })

  const { redirectUrl } = useRedirectUrlWithCacheKey([orderItem.id])

  return (
    <ListItem
      boxProps={{ alignItems: 'center', borderBottom: '1px dashed', padding: 'large' }}
      disableHover
    >
      <Box flexDirection="column">
        <Box flexDirection="row" alignItems="center">
          <Box flexDirection="column">
            <Box fontSize="small">
              <Text>{publication.title}</Text>
              <Text color="bodyFontLightColor" marginLeft="small">
                {publicationDateObj?.toFormat('ccc dd LLL')}
              </Text>
            </Box>

            <Box fontSize="xsmall" marginTop="medium">
              <Text color="bodyFontLightColor">
                {buildItemTitle({ orderableItem: orderItem, excludeOptionsString: true })}
              </Text>

              {publicationPackage.title && (
                <Text color="bodyFontLightColor" marginLeft="small">
                  | {publicationPackage.title}
                </Text>
              )}

              {orderBundle.title && (
                <Text color="bodyFontLightColor" marginLeft="small">
                  | {orderBundle.title}
                </Text>
              )}
            </Box>

            <Box fontSize="xsmall" marginY="medium" width="auto">
              <Text color="bodyFontLightColor" marginRight="small">
                {bookingStatusString}
              </Text>
              {isPaginated ? <Text color="green">(Paginated)</Text> : <Text color="red">(Not Paginated)</Text>}
            </Box>
          </Box>

          <Box marginLeft="auto" width="auto">
            <Button
              buttonStyle="secondaryUtility"
              onClick={() => manageOrderItem()}
              size="medium"
              // @ts-expect-error TS2322
              width="auto"
            >
              <FontAwesomeIcon icon={faPencilAlt} />
            </Button>
          </Box>
        </Box>

        <OrderItemOrQuoteItemManagement
          enabledFeatureKeys={['artwork.create', 'artwork.edit']}
          itemPayload={orderItemPayload}
          redirectUrl={redirectUrl}
        />
      </Box>
    </ListItem>
  )
}

export default OrderItem
